var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApppointment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Set",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#40C4FF;}\n\t.st1{fill:#263238;}\n\t.st2{fill:#FFD740;}\n\t.st3{fill:#FF5252;}\n\t.st4{fill:#4DB6AC;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{fill:#4FC3F7;}\n\t.st7{fill:#37474F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M14.5,9H11c-1.381,0-2.5,1.119-2.5,2.5V19h50v-7.5c0-1.381-1.119-2.5-2.5-2.5h-3.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 28.5,
    className: "st2",
    width: 50,
    height: 7.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M18,14L18,14c-0.828,0-1.5-0.672-1.5-1.5v-7C16.5,4.672,17.172,4,18,4h0c0.828,0,1.5,0.672,1.5,1.5v7 C19.5,13.328,18.828,14,18,14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18,14.5c-1.103,0-2-0.897-2-2v-7c0-1.103,0.897-2,2-2s2,0.897,2,2v7C20,13.603,19.103,14.5,18,14.5z M18,4.5 c-0.551,0-1,0.449-1,1v7c0,0.551,0.449,1,1,1s1-0.449,1-1v-7C19,4.949,18.551,4.5,18,4.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M33.5,14L33.5,14c-0.828,0-1.5-0.672-1.5-1.5v-7C32,4.672,32.672,4,33.5,4h0C34.328,4,35,4.672,35,5.5v7 C35,13.328,34.328,14,33.5,14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.5,14.5c-1.103,0-2-0.897-2-2v-7c0-1.103,0.897-2,2-2s2,0.897,2,2v7C35.5,13.603,34.603,14.5,33.5,14.5z  M33.5,4.5c-0.551,0-1,0.449-1,1v7c0,0.551,0.449,1,1,1s1-0.449,1-1v-7C34.5,4.949,34.051,4.5,33.5,4.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M49,14L49,14c-0.828,0-1.5-0.672-1.5-1.5v-7C47.5,4.672,48.172,4,49,4l0,0c0.828,0,1.5,0.672,1.5,1.5v7 C50.5,13.328,49.828,14,49,14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49,14.5c-1.103,0-2-0.897-2-2v-7c0-1.103,0.897-2,2-2s2,0.897,2,2v7C51,13.603,50.103,14.5,49,14.5z M49,4.5 c-0.551,0-1,0.449-1,1v7c0,0.551,0.449,1,1,1s1-0.449,1-1v-7C50,4.949,49.551,4.5,49,4.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30,9.5h-8.5C21.224,9.5,21,9.276,21,9s0.224-0.5,0.5-0.5H30c0.276,0,0.5,0.224,0.5,0.5S30.276,9.5,30,9.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.5,9.5H37c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h8.5C45.776,8.5,46,8.724,46,9 S45.776,9.5,45.5,9.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.5,19.5h-50C8.224,19.5,8,19.276,8,19v-7.5c0-1.654,1.346-3,3-3h3.5C14.776,8.5,15,8.724,15,9 s-0.224,0.5-0.5,0.5H11c-1.103,0-2,0.897-2,2v7h49v-7c0-1.103-0.897-2-2-2h-3.5C52.224,9.5,52,9.276,52,9s0.224-0.5,0.5-0.5H56 c1.654,0,3,1.346,3,3V19C59,19.276,58.776,19.5,58.5,19.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 51,
    cy: 51,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51,63.5c-6.893,0-12.5-5.607-12.5-12.5S44.107,38.5,51,38.5S63.5,44.107,63.5,51S57.893,63.5,51,63.5z  M51,39.5c-6.341,0-11.5,5.159-11.5,11.5S44.659,62.5,51,62.5S62.5,57.341,62.5,51S57.341,39.5,51,39.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.143,53.5H11c-1.654,0-3-1.346-3-3V21c0-0.276,0.224-0.5,0.5-0.5S9,20.724,9,21v29.5c0,1.103,0.897,2,2,2 h26.143c0.276,0,0.5,0.224,0.5,0.5S37.419,53.5,37.143,53.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M48.722,56.389c-0.384,0-0.768-0.146-1.061-0.439l-4.243-4.243c-0.586-0.585-0.586-1.535,0-2.121 s1.535-0.586,2.121,0l3.182,3.182l6.717-6.717c0.586-0.586,1.535-0.586,2.121,0c0.586,0.585,0.586,1.536,0,2.121l-7.778,7.778 C49.49,56.243,49.106,56.389,48.722,56.389z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.722,56.889c-0.534,0-1.036-0.208-1.414-0.586l-4.243-4.243c-0.378-0.377-0.586-0.879-0.586-1.414 c0-0.534,0.208-1.036,0.586-1.414c0.756-0.756,2.072-0.756,2.828,0l2.829,2.829l6.364-6.364c0.779-0.78,2.049-0.78,2.828,0 c0.378,0.377,0.586,0.88,0.586,1.414s-0.208,1.037-0.586,1.414l-7.778,7.778C49.758,56.681,49.256,56.889,48.722,56.889z  M44.479,49.647c-0.256,0-0.512,0.098-0.707,0.292c-0.189,0.189-0.293,0.44-0.293,0.707s0.104,0.518,0.293,0.707l4.243,4.243 c0.378,0.378,1.036,0.378,1.414,0l7.778-7.778c0.189-0.189,0.293-0.44,0.293-0.707s-0.104-0.518-0.293-0.707 c-0.39-0.39-1.025-0.389-1.414,0l-6.717,6.718c-0.195,0.195-0.512,0.195-0.707,0l-3.183-3.182 C44.991,49.745,44.735,49.647,44.479,49.647z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21,53.5c-0.276,0-0.5-0.224-0.5-0.5V21c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v32 C21.5,53.276,21.276,53.5,21,53.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.5,53.5c-0.276,0-0.5-0.224-0.5-0.5V21c0-0.276,0.224-0.5,0.5-0.5S34,20.724,34,21v32 C34,53.276,33.776,53.5,33.5,53.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46,38.42c-0.276,0-0.5-0.224-0.5-0.5V21c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v16.92 C46.5,38.197,46.276,38.42,46,38.42z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.5,39.678c-0.276,0-0.5-0.224-0.5-0.5V21c0-0.276,0.224-0.5,0.5-0.5S59,20.724,59,21v18.178 C59,39.454,58.776,39.678,58.5,39.678z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.5,29h-50C8.224,29,8,28.776,8,28.5S8.224,28,8.5,28h50c0.276,0,0.5,0.224,0.5,0.5S58.776,29,58.5,29z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.5,36.5h-50C8.224,36.5,8,36.276,8,36s0.224-0.5,0.5-0.5h50c0.276,0,0.5,0.224,0.5,0.5 S58.776,36.5,58.5,36.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.178,44H8.5C8.224,44,8,43.776,8,43.5S8.224,43,8.5,43h30.678c0.276,0,0.5,0.224,0.5,0.5 S39.454,44,39.178,44z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5,10.5H1c-0.276,0-0.5-0.224-0.5-0.5S0.724,9.5,1,9.5h4c0.276,0,0.5,0.224,0.5,0.5S5.276,10.5,5,10.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.5,3.5h-4C7.224,3.5,7,3.276,7,3s0.224-0.5,0.5-0.5h4C11.776,2.5,12,2.724,12,3S11.776,3.5,11.5,3.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.5,5.5C9.224,5.5,9,5.276,9,5V1c0-0.276,0.224-0.5,0.5-0.5S10,0.724,10,1v4C10,5.276,9.776,5.5,9.5,5.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3,12.5c-0.276,0-0.5-0.224-0.5-0.5V8c0-0.276,0.224-0.5,0.5-0.5S3.5,7.724,3.5,8v4 C3.5,12.276,3.276,12.5,3,12.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.5,58.5h-2c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h2c0.276,0,0.5,0.224,0.5,0.5 S32.776,58.5,32.5,58.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.5,58.5h-15c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h15c0.276,0,0.5,0.224,0.5,0.5 S28.776,58.5,28.5,58.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApppointment);
export default __webpack_public_path__ + "static/media/apppointment.1eb217e7ab89d2ddf57c11823b4acabf.svg";
export { ForwardRef as ReactComponent };